export default {
  pageTitle: 'パッチ補修サービス',
  metaDescription: 'TEFはシェルおよび配管の漏れに対する現地パッチ補修サービスを提供し、分解や運搬なしで迅速かつ低コストな修理を実現します。',
  sidebar: {
    heading: 'メンテナンス＆修繕一覧',
    weldingOverlay: '肉盛り溶接',
    patching: 'パッチ補修',
    piping: '配管',
    reshell: 'シェル取替え',
    retubing: 'チューブ取替え',
  },
  title: 'パッチ補修',
  heading: 'シェルおよび配管漏れに対する現場パッチ補修サービス',
  paragraph1: '当社は、シェルおよび配管の漏れに対応する効率的で信頼性の高いパッチ補修ソリューションを、お客様の現場にて直接ご提供いたします。可搬式の機材と経験豊富な技術者により、迅速かつ確実な補修を実現し、ダウンタイムの最小化とシステムのさらなる損傷防止に貢献します。',
  paragraph2: '現場対応方式により、分解や運搬の必要がなく、コストを抑えた利便性の高いソリューションとなります。一時的な応急処置であっても長期的な補修であっても、お客様の運用ニーズに合わせた高品質な施工をお約束いたします。',
  steps: {
    step1: '外側保温材の撤去',
    step2: 'シェル外側パッチ補修',
    step3: 'シェル内側補修',
    step4: 'シェル外側パッチ補修',
    step5: 'シェル内側パッチ補修',
    step6: 'ノズル外側パッチ補修',
    step7: 'シェル内側',
  },
};
